import { createApp } from 'vue'
import App from './App.vue'

import router from './router'

import { createPinia } from 'pinia'

import Chessboard from './js/henry-chessboard.js'
import "@/css/henry-chessboardjs.css"

// https://pinia.vuejs.org/core-concepts/outside-component-usage.html#single-page-applications


import HoneybadgerVue from '@honeybadger-io/vue'

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import '@/css/henry.css'

// for cm-chessboard
import './css/chessboard.css';
import './css/arrows.css';
import './css/markers.css';
import "./css/promotion-dialog.css"

/* Theme variables */
import './theme/variables.css';





const pinia = createPinia()
const app = createApp(App)

app.use(IonicVue)
app.use(router)
app.use(pinia)

import { useConnectionStore } from '@/stores/connectionStore';
const connectionStore = useConnectionStore()
const verbalVersion = connectionStore.getVersion

const honeybadgerConfig = {
  apiKey: 'hbp_Wko63RgGZzhwHwL2LbOKXl01ZUVhf01rXQyU',
  environment: 'production',
  revision : verbalVersion
}

if (process.env.NODE_ENV === 'production') {
  console.log("**** this is production with HoneyBadger Error Trapping")
  app.use(HoneybadgerVue, honeybadgerConfig)
}
else {
  console.log("**** this is DEVELOPMENT")
}

router.isReady().then(() => {
  app.mount('#app');
});

// createApp(App).use(createPinia()).use(router).mount('#app')
